import { useMutation, useQueryClient } from '@tanstack/react-query'
import { profileService } from '@/services/profileService'
import type { ProfileSettings } from '@/types'
import { toast } from '@/stores/toastStore'

/**
 * Hook to update profile settings (theme, visibility, etc.)
 */
export function useUpdateProfileSettings() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (settings: ProfileSettings) =>
      profileService.updateProfileSettings(settings),
    onSuccess: () => {
      // Invalidate current user query to refetch updated data
      queryClient.invalidateQueries({ queryKey: ['currentUser'] })
      toast.success('Settings saved successfully!')
    },
    onError: (error: any) => {
      // Don't show error if API endpoint doesn't exist yet (404/500)
      // This allows testing the UI before backend is ready
      const status = error.response?.status
      if (status && status !== 404 && status !== 500 && status !== 501) {
        const message =
          error.response?.data?.message || 'Failed to save settings'
        toast.error(message)
      }
      console.error('Profile settings save error:', error)
    },
  })
}
